import Icon, { IconProps } from 'approot/shared/icons/icon';
import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/navigation/nav-school-bag.svg';

const IconNavSchoolBag = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconNavSchoolBag;
